module.exports = __webpack_public_path__ + "img/released.9fc3de9c.svg";